import { IButtonWithIcon } from 'interfaces/components/buttonWithIcon';

const ButtonWithIcon = ({
  prefixIcon,
  prefixIconStyle,
  prefixIconAlt,
  suffixIcon,
  suffixIconStyle,
  suffixIconAlt,
  label,
  className,
  textStyle,
  onClick,
  id,
  disabled
}: IButtonWithIcon) => {
  return (
    <div
      className={`${className} ${disabled ? '!cursor-not-allowed' : ''}`}
      onClick={disabled ? undefined : onClick}
      id={id}
    >
      <div className='flex items-center gap-1'>
        <img src={prefixIcon} alt={prefixIconAlt} className={prefixIconStyle} />
        <p className={textStyle}>{label}</p>
      </div>
      <div className='flex items-center'>
        <img src={suffixIcon} alt={suffixIconAlt} className={suffixIconStyle} />
      </div>
    </div>
  );
};

export default ButtonWithIcon;
